export default {
  HTTP404: {
    type: 'HTTP404',
    redirectUrl: '/errors/HTTP404.html',
    error: 'Not Found'
  }
};
